import React from "react";

import { LocalizeKey, typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";

import { AquariusButton } from "../AquariusButton";
import { AquariusButtonGroup } from "../AquariusButtonGroup";

interface IConfirmCancelButtonsProps {
  isLoading?: boolean;
  disabled?: boolean;
  onCancel: (x?: any) => void;
  onConfirm: (x?: any) => void;
  cancelTextOverride?: LocalizeKey;
  confirmTextOverride?: LocalizeKey;
  showConfirmButton?: boolean;
  showConfirmState?: boolean;
  addClassName?: string;
}

export const ConfirmCancelButtons = ({
  isLoading,
  disabled,
  onCancel,
  onConfirm,
  cancelTextOverride,
  confirmTextOverride,
  addClassName,
  showConfirmButton = true,
  showConfirmState = false,
}: IConfirmCancelButtonsProps) => (
  <AquariusButtonGroup addClassName={addClassName} topBorder data-testid="confirm-cancel-btns">
    <AquariusButton onClick={onCancel} sx={{ whiteSpace: "nowrap" }} disabled={isLoading}>
      {typedLocalize(cancelTextOverride ?? "general.cancelBtn")}
    </AquariusButton>
    {showConfirmButton ? (
      <AquariusButton
        filled
        onClick={onConfirm}
        isLoading={isLoading}
        disabled={disabled}
        showConfirm={showConfirmState}
      >
        {typedLocalize(confirmTextOverride ?? "general.confirmChangesBtn")}
      </AquariusButton>
    ) : (
      <React.Fragment />
    )}
  </AquariusButtonGroup>
);
